/**
 * HELPER_PROVIDERS
 */
import { AuthGuard } from './auth-guard';
import { DevOnlyGuard } from './dev-only-guard';
import { PermissionGuard, PermissionResolver } from './permission-helpers';
import { ModalService } from './modal-helpers';
import { ComponentCounterService } from './component-counter';
import { ExitEditGuard } from './edit-guard/edit-guard.helper';
import { TranslationGuard } from './i18n-guard/translation.guard';
export * from './ag-grid-helpers';

export const HELPER_PROVIDERS: any[] = [
  ExitEditGuard,
  AuthGuard,
  DevOnlyGuard,
  PermissionResolver,
  PermissionGuard,
  ModalService,
  ComponentCounterService,
  TranslationGuard,
];
